// Onboarding
export const ONBOARDING_ENDPOINT_STAGE =
    "https://czsakdfvxvgsbekidfiyacm74a.appsync-api.ap-northeast-1.amazonaws.com/graphql"
export const ONBOARDING_API_KEY_STAGE = "da2-5imm3dpmlrch5ara73okjxlqd4"

export const ONBOARDING_ENDPOINT_PROD =
    "https://s4572gw3ejderoocbtatqhmjaq.appsync-api.ap-southeast-1.amazonaws.com/graphql"
export const ONBOARDING_API_KEY_PROD = "da2-dvr74csfjneurpunylk4xgl43e"

// Liquidity mining
export const LM_ENDPOINT_STAGE = "https://35bjttmsnjamhjwemncbhnruuu.appsync-api.ap-northeast-1.amazonaws.com/graphql"
export const LM_API_KEY_STAGE = "da2-7pcqlldqfjc2pisylcv7vz26wq"

export const LM_ENDPOINT_PROD = "https://yvolsu5cy5gbhmwz7mxdykf744.appsync-api.ap-southeast-1.amazonaws.com/graphql"
export const LM_API_KEY_PROD = "da2-afbouqqkr5at5dqa6kjjm6v3ae"

// Gas rebate
export const GAS_REBATE_ENDPOINT_STAGE = "https://ceb6lszp2jfwhlzrj67rqbee4y.appsync-api.ap-northeast-1.amazonaws.com/graphql"
export const GAS_REBATE_API_KEY_STAGE = "da2-6man3aqbgbfsxm75gxbxiz2boy"

export const GAS_REBATE_ENDPOINT_PROD =
    "https://glsx5xgwdjgn5eyk47kol3b6ma.appsync-api.ap-southeast-1.amazonaws.com/graphql"
export const GAS_REBATE_API_KEY_PROD = "da2-3zku34te2jehjk7v6e4nahvuoe"
